export default __webpack_public_path__ + "static/media/golf-ball.644c65ba.jpg";